import { ReactNode } from "react";
import CustomTypography from "@/components/Typography/CustomTypography";
import FormItem from "antd/es/form/FormItem";
import resLabels from "./labels";

type ManualQuoteResElementProps = {
  attributeName: string;
  value: string | unknown;
  children: ReactNode;
  valueForLabel: string | unknown;
  required: boolean;
  pattern?: RegExp;
  patternMessage?: string;
};

export default function ManualQuoteResElement({
  attributeName,
  value,
  children,
  valueForLabel,
  required,
  pattern,
  patternMessage,
}: ManualQuoteResElementProps) {
  const initialValue =
    value !== null && value !== undefined ? value.toString() : "";

  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="grid grid-cols-2 items-center bg-primaryDim py-2 px-3 rounded-lg border border-gray-surface h-10">
        <CustomTypography weight={"light"} size={"13px"}>
          {resLabels[attributeName as keyof typeof resLabels]}
        </CustomTypography>
        <CustomTypography weight={"light"} size={"13px"}>
          {valueForLabel
            ? attributeName === "power"
              ? [valueForLabel, "kW"].join("")
              : valueForLabel.toString()
            : "-"}
        </CustomTypography>
      </div>
      <div>
        <label>
          <FormItem
            validateTrigger="onBlur"
            name={attributeName}
            initialValue={initialValue}
            rules={[
              {
                required: required,
                message: "This field is required",
              },
              {
                pattern: pattern || undefined,
                message: patternMessage || undefined,
              },
            ]}
          >
            {children}
          </FormItem>
        </label>
      </div>
    </div>
  );
}
